import React from 'react';
import { useTranslation } from 'react-i18next';
import isEqual from 'lodash/isEqual';
import cn from 'classnames';
import PropTypes from 'prop-types';

import {
  ClearButton,
  DatePicker,
  SelectDropDown
} from 'components/common/Elements/Elements';

import classes from './FiltersBlock.module.scss';

const FiltersBlock = ({
  filter,
  setFilter,
  startFilter,
  setStartFilter,
  filters,
  selectLoader,
  trigerResetDatePicker,
  resetAllfilters,
  filterButton,
  setVisibleFilterSave,
  setVisibleFilterEdit,
  changeFilter
}) => {
  const { t } = useTranslation(['activity']);

  const numberОfFilters = 12;

  const handleFilter = e => {
    setFilter({ ...filter, [e.target]: e.value, currentPage: 1 });
    setVisibleFilterSave('button');
    if (changeFilter !== 'Default') {
      setVisibleFilterEdit(true);
    }
  };

  const handleLastDeviceLogin = value => {
    const key = 'lastDeviceLogin';
    checkAndSetFilter(key, value);
  };
  const handleLastPostureCheckAt = value => {
    const key = 'lastPostureCheckAt';
    checkAndSetFilter(key, value);
  };

  function checkAndSetFilter(key, value) {
    if (!isEqual(filter[key], value)) {
      setFilter({ ...filter, [key]: value, currentPage: 1 });
      // in cross filters after changing the date you need to get new filters
      setStartFilter(!startFilter);
      setVisibleFilterSave('button');
      if (changeFilter !== 'Default') {
        setVisibleFilterEdit(true);
      }
    }
  }

  return (
    <div className={cn(filterButton ? classes.filters : classes.filters_close)}>
      <SelectDropDown
        options={filters.deviceType}
        input={{ value: filter.deviceType, onChange: handleFilter }}
        name={'deviceType'}
        label={t('activity:filters.DEVICE_TYPE')}
        multi
        reload
        closeTrigger={{
          trigger: startFilter,
          setTrigger: setStartFilter
        }}
        selectLoader={selectLoader}
      />
      <SelectDropDown
        options={filters.os}
        input={{ value: filter.os, onChange: handleFilter }}
        name={'os'}
        label={t('activity:filters.OS')}
        multi
        reload
        closeTrigger={{
          trigger: startFilter,
          setTrigger: setStartFilter
        }}
        selectLoader={selectLoader}
      />
      <SelectDropDown
        options={filters.osVersion}
        input={{ value: filter.osVersion, onChange: handleFilter }}
        name={'osVersion'}
        label={t('activity:filters.OS_VERSION')}
        multi
        reload
        closeTrigger={{
          trigger: startFilter,
          setTrigger: setStartFilter
        }}
        selectLoader={selectLoader}
      />
      <SelectDropDown
        options={filters.appVersion}
        input={{ value: filter.appVersion, onChange: handleFilter }}
        name={'appVersion'}
        label={t('activity:LABEL_APP_VERSION')}
        multi
        reload
        closeTrigger={{
          trigger: startFilter,
          setTrigger: setStartFilter
        }}
        selectLoader={selectLoader}
      />
      <SelectDropDown
        options={filters.timezone}
        input={{ value: filter.timezone, onChange: handleFilter }}
        name={'timezone'}
        label={t('activity:filters.TIMEZONE')}
        multi
        reload
        closeTrigger={{
          trigger: startFilter,
          setTrigger: setStartFilter
        }}
        selectLoader={selectLoader}
      />
      <SelectDropDown
        options={filters.role}
        input={{ value: filter.role, onChange: handleFilter }}
        name={'role'}
        label={t('activity:filters.ROLE')}
        multi
        reload
        closeTrigger={{
          trigger: startFilter,
          setTrigger: setStartFilter
        }}
        selectLoader={selectLoader}
      />
      <SelectDropDown
        options={filters.groups}
        input={{ value: filter.groups, onChange: handleFilter }}
        name={'groups'}
        label={t('activity:filters.GROUPS')}
        multi
        reload
        closeTrigger={{
          trigger: startFilter,
          setTrigger: setStartFilter
        }}
        selectLoader={selectLoader}
      />
      <DatePicker
        label={t('activity:filters.LAST_LOGIN')}
        input={{
          value: filter.lastDeviceLogin,
          onChange: handleLastDeviceLogin
        }}
        trigerResetDatePicker={trigerResetDatePicker}
      />
      <SelectDropDown
        options={filters.idp}
        input={{ value: filter.idp, onChange: handleFilter }}
        name={'idp'}
        label={t('activity:filters.IDP_ABBREVIATION')}
        multi
        reload
        closeTrigger={{
          trigger: startFilter,
          setTrigger: setStartFilter
        }}
        selectLoader={selectLoader}
      />
      <SelectDropDown
        options={filters['attachedPolicy']}
        input={{
          value: filter['attachedPolicy'],
          onChange: handleFilter
        }}
        name={'attachedPolicy'}
        label={t('activity:filters.ATTACHED_POLICY')}
        multi
        closeTrigger={{
          trigger: startFilter,
          setTrigger: setStartFilter
        }}
        reload
        selectLoader={selectLoader}
      />
      <DatePicker
        label={t('activity:filters.LAST_DPC')}
        input={{
          value: filter.lastPostureCheckAt,
          onChange: handleLastPostureCheckAt
        }}
        trigerResetDatePicker={trigerResetDatePicker}
      />
      <SelectDropDown
        options={filters.postureCheckStatus}
        input={{ value: filter.postureCheckStatus, onChange: handleFilter }}
        name={'postureCheckStatus'}
        label={t('activity:filters.DPC_STATUS')}
        multi
        reload
        closeTrigger={{
          trigger: startFilter,
          setTrigger: setStartFilter
        }}
        selectLoader={selectLoader}
      />
      <ClearButton
        onClick={() => resetAllfilters(false, true, false, true)}
        numberОfFilters={numberОfFilters}
      />
    </div>
  );
};

FiltersBlock.propTypes = {
  filter: PropTypes.object,
  setFilter: PropTypes.func,
  startFilter: PropTypes.bool,
  setStartFilter: PropTypes.func,
  filterButton: PropTypes.bool,
  filters: PropTypes.object,
  selectLoader: PropTypes.bool,
  trigerResetDatePicker: PropTypes.bool,
  resetAllfilters: PropTypes.func,
  setVisibleFilterSave: PropTypes.func,
  setVisibleFilterEdit: PropTypes.func,
  changeFilter: PropTypes.string
};

export default FiltersBlock;
